<template lang="pug">

  .pageGroupsContainer

    //-
      -
      -
      -
      - CABEÇALHO DA LISTA
      -
      -
      -
      -

    .groupsHeader

      .sosGroupScreen__row.mb-2

        .sosGroupScreen__column.sosGroupScreen__column--50.sosGroupScreen__column--left

          h2.blockTitle Grupos
          span.blockDescription {{ pageDescription }}

        //- .sosGroupScreen__column.sosGroupScreen__column--50.sosGroupScreen__column--right

          sos-button(@buttonClick="goToCreateGroup" size="medium" color="success" buttonLabel="NOVO GRUPO" buttonIcon="mdi-plus" buttonIconSize="16" :disabled="loadingGroups !== 'LOADED' && loadingGroups !== 'NOT_FOUND' && loadingGroups !== 'NOT_ADMIN'" :pulse="loadingGroups === 'NOT_FOUND' || loadingGroups === 'NOT_ADMIN'")

    //-
      -
      -
      -
      - LISTA
      -
      -
      -
      -

    .pageBody

      //-
        -
        - ERRO NO CARREGAMENTO/PROCESSAMENTO
        -
        -

      .groupsContainer(v-if="loadingGroups === 'ERROR_PROFILE_NOT_FOUND'")

        .text-center

          span.startTitle Não foi possível carregar a lista!
          br
          .pt-2
            span Por favor, recarregue a página ou&nbsp;
            a(href="https://wa.me/?phone=5513992061010" target="_blank") converse com o nosso suporte.

      //-
        -
        - AGUARDANDO
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'WAITING'")

        .loadingResult

          .buttonLoader
            span
          span.loadingText Inicializando...

      //-
        -
        - CARREGOU, MAS NÃO TEM GRUPOS VÁLIDOS
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'LOADING'")

        .loadingResult

          span.screenStatus Carregando grupos
          br
          .groupProgressBar
            .groupProgressBarInner(:style="{ width: ((loadingGroupsProgress/(userSession.userGroupsAmount || 0)) * 100) + '%' }")

      //-
        -
        - CARREGOU, MAS NÃO TEM GRUPOS VÁLIDOS
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'NOT_FOUND' || loadingGroups === 'NOT_ADMIN'")

        .text-center

          span.startTitle VAMOS COMEÇAR
          br
          .pt-2 Fale com o responsável pela gestão de grupos, pois você ainda não faz parte de nenhum.

      //-
        -
        - CARREGOU E TEM GRUPOS
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'LOADED'")

        table#sosGroupsTable(border="0" cellspacing="0" cellpadding="0")

          thead

            tr.sosGroupItem.sosGroupItemHeader
              th Nome do grupo
              //- th.text-center Membros criam plantões
              //- th.text-center Membros largam plantões
              th(width="350") Descrição
              //- th(width="50") DEBUG
              th.text-center Locais
              th(width="180").last.text-center Ações

          tbody

            tr(v-for="(groupItem, groupItemIndex) in groups" :key="'grupo_' + groupItem.groupID").sosGroupItem

              td(data-label="Nome do grupo")

                .groupItemImage(:style="{backgroundImage: ('url(' + groupItem.groupImage + ')')}")
                span.groupItemName {{ groupItem.groupName || '&nbsp;' }}

              td(data-label="Descrição")

                span {{ groupItem.groupDescription || '&nbsp;' }}

              td(data-label="Locais").text-center

                span {{ groupItem.groupLocations.length || '&nbsp;' }}

              td(data-label="Ações").text-center.last

                sos-button(@buttonClick="handleView(groupItem.groupID)" size="regular" buttonLabel="Ver Escalas" buttonIcon="" buttonIconSize="16" :uppercase="false")
                //- sos-button(@buttonClick="handleView(groupItem.groupID)" size="regular" buttonLabel="Ver Escalas" buttonIcon="mdi-eye" buttonIconSize="16")

      //-
        -
        - DESLOGANDO
        -
        -

      .groupsContainer(v-else-if="loadingGroups === 'LEAVING'")

        .loadingResult

          .buttonLoader
            span
          span.loadingText Saindo...

      //-
        -
        - ESSA CONDIÇAO É CHAMADA QUANDO O USUÁRIO ACABOU DE LOGAR.
        - PARECE QUE NESSE MOMENTO O COMPONENTE AINDA NÃO RECEBEU/CARREGOU AS VARIÁVEIS DA STORE.
        -
        -

      .groupsContainer(v-else)

        .loadingResult

          .buttonLoader
            span
          span.loadingText Processando...

</template>

<script>
  import { mapState } from 'vuex'

  import SosButton from '@/components/SosButton'

  export default {
    name: 'GroupsList',

    components: {
      'sos-button': SosButton,
    },

    /* data: () => ({
      showEditGroupModal: false,
      showEditGroupModalItem: null,
    }), */

    computed: {
      ...mapState(['userSession', 'groups', 'loadingGroups', 'loadingGroupsProgress', 'loadingUsers', 'loadingUsersProgress', 'loadingUsersMax']),

      pageDescription ()
      {
        const isError = this.loadingGroups === 'ERROR_PROFILE_NOT_FOUND'
        const isExiting = this.loadingGroups === 'LEAVING'
        const isWaiting = this.loadingGroups === 'WAITING'
        const isLoading = this.loadingGroups === 'LOADING'

        return (
          isError ? 'Erro!' : (
            isExiting ? 'Saindo...' : (
              isWaiting ? 'Inicializando...' : (
                isLoading ? 'Carregando...' : (
                  this.groups.length === 0 ? 'Você não está gerenciando nenhum grupo.' : (
                    this.groups.length === 1 ? 'Você está gerenciando 1 grupo.' : (
                      `Você está gerenciando ${this.groups.length} grupos.`
                    )
                  )
                )
              )
            )
          )
        )
      },
    },

    /* watch: {
      '$store.state.groups': function () {
        // [06/02/25] console.log('::: LISTA DE GRUPOS [watch]:', this.$store.state.groups)
      },
    }, */

    /* mounted () {
      // [06/02/25] console.log('GroupsList')
    }, */

    methods: {
      handleView (groupID) {
        return this.$router.push(`/admin/grupos/${groupID}/escalas`)
      },
    },
  }
</script>

<style lang="sass">

  .groupItemImage
    display: inline-block
    vertical-align: middle
    width: 50px
    height: 50px
    border-radius: 50%
    background-position: center
    background-size: cover
    background-repeat: no-repeat
    // border: 2px solid rgba(0, 0, 0, 0.1)
    box-shadow: 0 5px 7px -3px rgba(0, 0, 0, 0.2)

  .groupItemName
    display: inline-block
    vertical-align: middle
    height: 40px
    max-width: 500px

    padding-left: 15px
    // padding-left: 55px
    // max-width: 210px

    line-height: 40px

  @media (max-width: 768px)

    // .scaleslistEditColumn
      // width: auto

    // .userItemImage .userItemName
      // padding-left: 50px

  .startTitle
    font-size: 18px
    font-weight: 900

  .groupItem
    width: 100%
    padding: 10px 0
    font-size: 0
    line-height: 0

  .groupItemInner
    border-width: 0.2px
    border-style: solid
    border-color: rgba(0, 0, 0, 0.1)
    border-radius: 5px
    box-shadow: 0px 3px 7px -5px rgba(0, 0, 0, 0.3)
    margin-left: 0 !important
    margin-right: 0 !important
    display: flex
    flex-wrap: wrap
    flex: 1 1 auto
    -ms-flex-wrap: wrap
    -webkit-box-flex: 1
    -ms-flex: 1 1 auto
    @media (max-width: 764px)
      flex-direction: column
    @media (max-width: 600px)
      padding: 12px 0

</style>
